export default "__VITE_ASSET__DO2PjBCS__"